var comparableConfig = {
  enabled: true,
  enableStickyButton: false,
  controlsType: 'float_controls',
  compareFields: {
    price: true,
    vendor: false,
    productType: true,
    tags: false,
    addToCart: true,
    enableOnAllOptions: false,
    options: [],
  },
  stickyButton: {
    content: 'text-icon',
    useIcon: true,
    position: 'right-bottom',
    iconSvg: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   width="121.805px" height="121.805px" viewBox="0 0 121.805 121.805" style="enable-background:new 0 0 121.805 121.805;"
   xml:space="preserve">
<g>
  <g>
    <path d="M121.805,109.623V21.926c0-2.692-2.181-4.873-4.871-4.873H92.572c-2.691,0-4.871,2.181-4.871,4.873v87.697
      c0,2.693,2.18,4.873,4.871,4.873h24.361C119.624,114.496,121.805,112.316,121.805,109.623z"/>
    <path d="M46.287,114.496h26.797c2.691,0,4.872-2.18,4.872-4.873V12.181c0-2.692-2.181-4.872-4.872-4.872H46.287
      c-2.692,0-4.873,2.18-4.873,4.872v97.442C41.414,112.316,43.594,114.496,46.287,114.496z"/>
    <path d="M4.872,46.286C2.18,46.286,0,48.466,0,51.158v58.465c0,2.693,2.18,4.873,4.872,4.873h24.361
      c2.692,0,4.872-2.18,4.872-4.873V51.158c0-2.692-2.18-4.872-4.872-4.872H4.872z"/>
  </g>
</g>
</svg>
`,
  },
  floatControls: {"position":"under-card","elementType":"checkbox","floatX":6,"floatY":6,"showOnHover":false},
  enablePages: {
    enableOnAllCollections: true,
    enableOnProductPages: true,
    exceptCollections: [],
    enableOnHomepage: false,
    enableOnAnyPage: false,
  },
  styles: {"collectionCompareBtnBcolor":"#2f60ea","collectionCompareBtnContent":"text-icon","collectionCompareBtnTextColor":"#fff","collectionCompareBtnPosition":"right-bottom","collectionCompareBtnZindex":5501,"barActionsPosition":"right","tableMobileFixFirstColumn":false,"tableBestValueHighlightColor":"#ffffdf","tableAddToCartBackgroundColor":null,"tableSoldOutBackgroundColor":null,"tableGoToCheckoutUrl":"/cart","tableNoProductsUrl":"/","tableBooleanTrueColor":"#4d9902","tableBooleanFalseColor":"#b2b2b2","tableBorder":"separate"},
  table: {"backButton":{"enabled":false,"position":"before-table-centered","showIcon":true}},
  preselectedCompare: {"products":[]},
  openInPopup: true,
}

var comparableCustomFieldsByProduct = []

var comparableOptions = []

var comparableGroups = []

var comparableLocales = {"collection_compare_btn":"Compare","collection_in_comparison_btn":"In comparison","bar_compare_btn":"Compare","bar_close_btn":"Close","bar_add_to_compare_btn":"Add to compare","page_add_to_cart":"Add to cart","page_go_to_checkout":"Go to checkout","page_sold_out":"Sold out","page_show_only_differences":"Show only differences","page_show_all_features":"Show all features","page_close_compare":"Back"}
